import React, {useState, useEffect} from "react";
import "./pages.css";
import {PagesHero, SEO, WorkGallery} from "../components";
import {projects} from "../constants/Projects";
import ListGrid from "../components/WorkGallery/WorkGaleryGrids/ListGrid";

const ProjectList = () => {
  const [view, setView] = useState("grid");
  const [isMobile, setIsMobile] = useState(false);

  // Check for mobile screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Load view from localStorage on mount
  useEffect(() => {
    const storedView = localStorage.getItem("projectView");
    if (storedView === "grid" || storedView === "list") {
      setView(storedView);
    }
  }, []);

  // Save view to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("projectView", view);
  }, [view]);

  return (
    <main>
      <SEO
        title="Deep Kapadia | Frontend Project Portfolio | React & Next.js Work"
        description="Browse real-world projects crafted by Deep Kapadia — showcasing expertise in React, Next.js, Figma to Code conversions, UI architecture, and performance-focused development."
        keywords="Deep Kapadia Portfolio, Frontend Projects, React Project List, Next.js Portfolio, Figma to HTML Work, Web Development Portfolio, UI Development, Modern Frontend Examples, Responsive Design Projects"
        image="https://www.deepkapadia.work/images/preview.jpg"
        url="https://www.deepkapadia.work/projects"
      />

      <div className="page-project-list">
        <PagesHero
          subTitle="Explore My Work"
          title="My Projects"
          otherText1="Curious about what I’ve built?"
          otherText2="Dive into my featured projects."
          maskSubTitle="Projects That Speak"
          maskTitle="Discover Now"
          maskOtherText1="Built with precision and passion."
          maskOtherText2="Let’s build something amazing together."
        />

        {/* Tabs - hidden on mobile */}
        {!isMobile && (
          <div className="container tabs-project-view">
            <div className="view-tabs">
              <button
                className={`tab-btn ${view === "grid" ? "active" : ""}`}
                onClick={() => setView("grid")}
              >
                <i className="ri-grid-fill"></i>
              </button>
              <div className="tab-divider"> </div>
              <button
                className={`tab-btn ${view === "list" ? "active" : ""}`}
                onClick={() => setView("list")}
              >
                <i className="ri-list-view"></i>
              </button>
            </div>
          </div>
        )}

        {/* Conditional Component Rendering */}
        {isMobile ? (
          <WorkGallery isButtonHide={false} projects={projects} />
        ) : view === "grid" ? (
          <WorkGallery isButtonHide={false} projects={projects} />
        ) : (
          <ListGrid projects={projects} />
        )}
      </div>
    </main>
  );
};

export default ProjectList;
